import { defineStore } from 'pinia';
import dictionary from '@/dictionaries/MasterDictionary';

export const useSessionMessageStore = defineStore('session_message', {
  state: () => ({
    message: null,
    type: null

  }),
  actions: {
    successMessage(message) {
      this.message = message;
      this.type = dictionary.SESSION_MESSAGE.SUCCESS;
    },
    infoMessage(message) {
      this.message = message;
      this.type = dictionary.SESSION_MESSAGE.INFO;
    },
    errorMessage(message) {
      this.message = message;
      this.type = dictionary.SESSION_MESSAGE.ERROR;
    },
    warningMessage(message) {
      this.message = message;
      this.type = dictionary.SESSION_MESSAGE.WARNING;
    },
    cleanMessage() {
      this.message = null;
      this.type = null;
    }

  },
  getters: {
    hasMessage: (state) => !!state.message,

    getMessageType: (state) => {
      switch (state.type) {
        case dictionary.SESSION_MESSAGE.SUCCESS:
          return 'success';
        case dictionary.SESSION_MESSAGE.INFO:
          return 'info';
        case dictionary.SESSION_MESSAGE.ERROR:
          return 'error';
        case dictionary.SESSION_MESSAGE.WARNING:
          return 'warning';
      }
      return 'success';
    },

    getCurrentMessage: (state) => {
      return state.message;
    }
    
  }
})
